import React, { useEffect } from 'react';
import { QRCodeCanvas } from 'qrcode.react';

const ANDROID_URL = 'https://play.google.com/store/apps/details?id=com.deenroute.app';
const IOS_URL = 'https://apps.apple.com/app/deenroute/id6757677330';

function detectDevice() {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  if (/android/i.test(ua)) return 'android';
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return 'ios';
  return 'other';
}

const AppDownloadPage = () => {
  useEffect(() => {
    const device = detectDevice();
    if (device === 'android') {
      window.location.replace(ANDROID_URL);
    } else if (device === 'ios') {
      window.location.replace(IOS_URL);
    }
  }, []);

  // Only shown for desktop/unknown devices
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#aec597',
      color: '#222',
      fontFamily: 'inherit',
    }}>
      <h1>Download our app</h1>
      <p>Get the DeenRoute app for your device:</p>
      <div style={{ display: 'flex', gap: '1.5rem', margin: '1.5rem 0' }}>
        <a href={ANDROID_URL} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#222', background: '#fff', padding: '1rem 2rem', borderRadius: '8px', fontWeight: 'bold', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
          Google Play
        </a>
        <a href={IOS_URL} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#222', background: '#fff', padding: '1rem 2rem', borderRadius: '8px', fontWeight: 'bold', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
          App Store
        </a>
      </div>
      <div style={{ margin: '2rem 0' }}>
        <QRCodeCanvas value="https://deenroute.org/app" size={128} bgColor="#aec597" fgColor="#222" />
      </div>
      <small style={{ opacity: 0.7 }}>Scan the QR code on your mobile device to open this page</small>
    </div>
  );
};

export default AppDownloadPage;
